import { AppState, MarketInfo } from './interfaces';

export type Action =
	| { type: 'SET_EXPERTMODE'; value: AppState['expertMode'] }
	| { type: 'SET_BRAND'; value: AppState['brand'] }
	| { type: 'SET_MARKET'; value: Partial<AppState['market']> }
	| { type: 'SET_PASSWORD'; value: AppState['password'] }
	| { type: 'SET_DEVICES'; value: AppState['devices'] }
	| { type: 'SET_DEVICE'; value: AppState['device'] }
	| { type: 'SET_LANGUAGE'; value: AppState['language'] }
	| { type: 'SET_ORIENTATION'; value: AppState['orientation'] }
	| { type: 'SET_SHOW_SECOND_SCREEN'; value: AppState['show_second_screen'] }
	| { type: 'SET_USER_PASSWORD'; value: AppState['userPassword'] }
	| { type: 'SET_SCREEN'; value: AppState['screen'] }
	| { type: 'SET_ERRORS'; value: AppState['errors'] }
	| { type: 'SET_GO_TO_LABEL'; value: AppState['goToLabel'] }
	| { type: 'SET_SETUP'; value: AppState['setup'] }
	| { type: 'SET_OFFLINE'; value: AppState['offline'] }
	| { type: 'SET_PREVIEW'; value: AppState['preview'] }
	| { type: 'SET_PAIRING'; value: AppState['pairing'] }
	| { type: 'SET_PINPAIRING_ACTIVATIONRESPONSE'; value: AppState['pinpairingActivationResponse'] }
	| { type: 'SET_PINPAIRING_DEVICECODE'; value: AppState['pinpairingDeviceCode'] };

export const reducer = (state: AppState, action: Action): AppState => {
	switch (action.type) {
		case 'SET_EXPERTMODE':
			return { ...state, expertMode: action.value };
		case 'SET_BRAND':
			return { ...state, brand: action.value };
		case 'SET_MARKET':
			return {
				...state,
				market: { ...state.market, ...action.value } as MarketInfo //allows updates of singular properties
			};
		case 'SET_PASSWORD':
			return { ...state, password: action.value };
		case 'SET_DEVICES':
			return { ...state, devices: action.value };
		case 'SET_DEVICE':
			return { ...state, device: action.value };
		case 'SET_LANGUAGE':
			return { ...state, language: action.value };
		case 'SET_SHOW_SECOND_SCREEN':
			return { ...state, show_second_screen: action.value };
		case 'SET_ORIENTATION':
			return { ...state, orientation: action.value };
		case 'SET_USER_PASSWORD':
			return { ...state, userPassword: action.value };
		case 'SET_SCREEN':
			return { ...state, screen: action.value };
		case 'SET_ERRORS':
			return { ...state, errors: action.value };
		case 'SET_GO_TO_LABEL':
			return { ...state, goToLabel: action.value };
		case 'SET_SETUP':
			return { ...state, setup: action.value };
		case 'SET_OFFLINE':
			return { ...state, offline: action.value };
		case 'SET_PREVIEW':
			return { ...state, preview: action.value };
		case 'SET_PAIRING':
			return { ...state, pairing: action.value };
		case 'SET_PINPAIRING_ACTIVATIONRESPONSE':
			return { ...state, pinpairingActivationResponse: action.value };
		case 'SET_PINPAIRING_DEVICECODE':
			return { ...state, pinpairingDeviceCode: action.value };
		default:
			return state;
	}
};
